import { defineComponent as m, useCssVars as c, reactive as h, openBlock as d, createElementBlock as s, Fragment as f, renderList as g, unref as l, normalizeClass as y, normalizeStyle as b, renderSlot as p, createCommentVNode as k } from "vue";
const o = {
  text: {
    name: "text",
    height: "1rem",
    width: "100%",
    borderRadius: "0.25rem",
    margin: "0 0 0.25rem"
  },
  avatar: {
    name: "avatar",
    height: "40px",
    width: "40px",
    borderRadius: "50%",
    margin: "0 0 0.75rem"
  },
  image: {
    name: "image",
    height: "150px",
    width: "100%",
    borderRadius: "0.25rem",
    margin: "0 0 0.75rem"
  },
  button: {
    name: "button",
    height: "36px",
    width: "64px",
    borderRadius: "0.25rem",
    margin: "0 0 0.75rem"
  },
  chip: {
    name: "chip",
    height: "32px",
    width: "96px",
    borderRadius: "1rem",
    margin: "0 0.75rem 0.75rem 0"
  },
  divider: {
    name: "divider",
    height: "1px",
    width: "100%",
    borderRadius: "0",
    margin: "0 0 0.75rem"
  }
};
function S(e) {
  const t = v(e);
  return x(t);
}
function v(e) {
  return e.match(/^[^\s@]+(?:@\d+(?:\.\d+)?)?$/) ? e : "";
}
function x(e) {
  const t = Object.keys(o), [r, n = "1"] = e.split("@"), a = parseInt(n);
  return t.includes(r) ? { name: e, skeletonName: r, bonesCount: a } : {};
}
function q(e) {
  const {
    type: t,
    borderRadius: r,
    height: n,
    width: a
  } = e, i = {};
  return i["border-radius"] = r || o[t].borderRadius, i.height = n || o[t].height, i.width = a || o[t].width, i.margin = o[t].margin, i;
}
const w = { class: "vue-skeleton-loader" }, C = /* @__PURE__ */ m({
  __name: "VueSkeletonLoader",
  props: {
    loading: {
      type: Boolean,
      required: !1,
      default: !0
    },
    type: {
      type: String,
      required: !1,
      default: "text"
    },
    animation: {
      type: String,
      required: !1,
      default: "wave"
    },
    duration: {
      type: String,
      required: !1,
      default: "1.5s"
    },
    baseColor: {
      type: String,
      required: !1,
      default: "#0000001E"
    },
    highlightColor: {
      type: String,
      required: !1,
      default: "#FFFFFF66"
    },
    borderRadius: {
      type: [String, Number],
      required: !1,
      default: ""
    },
    height: {
      type: [String, Number],
      required: !1,
      default: ""
    },
    width: {
      type: [String, Number],
      required: !1,
      default: ""
    },
    timingFunction: {
      type: String,
      required: !1,
      default: "linear"
    },
    direction: {
      type: String,
      required: !1,
      default: "ltr"
    },
    skeletonStyle: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    skeletonClassName: {
      type: String,
      required: !1,
      default: ""
    }
  },
  setup(e) {
    c((i) => ({
      "9e346efe": e.baseColor,
      "616210f3": e.animation,
      "48316e45": e.duration,
      "249a139a": e.timingFunction,
      ddfaca00: e.highlightColor
    }));
    const t = e, { skeletonName: r, bonesCount: n } = S(t.type);
    let a = h({});
    if (n && n > 0) {
      const i = {
        type: r,
        borderRadius: t.borderRadius,
        height: t.height,
        width: t.width
      };
      a = q(i);
    }
    return (i, N) => (d(), s("div", w, [
      e.loading ? (d(!0), s(f, { key: 0 }, g(l(n), (u) => (d(), s("div", {
        class: y(["vue-skeleton-loader-bone", [
          `v-skeleton-loader-${l(r)}`,
          {
            "animation-disabled": !e.animation,
            "rtl-direction": e.direction === "rtl"
          },
          e.animation,
          e.skeletonClassName
        ]]),
        ref_for: !0,
        ref: "skeleton",
        key: u,
        style: b({ ...l(a), ...e.skeletonStyle })
      }, [
        p(i.$slots, "default", {}, void 0, !0)
      ], 6))), 128)) : k("", !0)
    ]));
  }
});
const F = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, a] of t)
    r[n] = a;
  return r;
}, L = /* @__PURE__ */ F(C, [["__scopeId", "data-v-429326cb"]]);
export {
  L as default
};
